import AutoStoriesOutlinedIcon from "@mui/icons-material/AutoStoriesOutlined";
import BuildOutlinedIcon from "@mui/icons-material/BuildOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import GppGoodOutlinedIcon from "@mui/icons-material/GppGoodOutlined";
import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import PsychologyOutlinedIcon from "@mui/icons-material/PsychologyOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import SubjectOutlinedIcon from "@mui/icons-material/SubjectOutlined";

export const NAV_GROUPS = [
  {
    label: "Setup",
    tabs: [
      {
        id: "instructions",
        label: "Instructions",
        icon: SubjectOutlinedIcon,
        sections: [
          { id: "details", label: "Details" },
          {
            id: "systemPrompt",
            label: "System prompt",
            hideForSystemAgent: true,
          },
        ],
      },
      {
        id: "model",
        label: "Model",
        icon: PsychologyOutlinedIcon,
        systemAgentVisible: true,
      },
      {
        id: "cost",
        label: "Operating cost",
        icon: PaymentsOutlinedIcon,
        systemAgentVisible: true,
      },
    ],
  },
  {
    label: "Capabilities",
    tabs: [
      {
        id: "tools",
        label: "Tools",
        icon: BuildOutlinedIcon,
        sections: [
          { id: "builtInTools", label: "Built-in tools" },
          { id: "mcpIntegrations", label: "MCP integrations" },
        ],
      },
      {
        id: "knowledge",
        label: "Knowledge",
        icon: MenuBookOutlinedIcon,
        sections: [
          { id: "indexStatus", label: "Index status" },
          { id: "files", label: "Files" },
          { id: "tables", label: "Tables" },
          { id: "manualContext", label: "Manual context" },
        ],
      },
      {
        id: "skills",
        label: "Skills",
        icon: AutoStoriesOutlinedIcon,
        sections: [
          { id: "enabledSkills", label: "Enabled skills" },
          { id: "docsAccess", label: "Docs access" },
        ],
      },
      {
        id: "approvalPolicies",
        label: "Approval policies",
        icon: GppGoodOutlinedIcon,
        hideForSystemAgent: true,
      },
      {
        id: "validation",
        label: "Output validation",
        icon: FactCheckOutlinedIcon,
      },
    ],
  },
  {
    label: "Channels",
    tabs: [
      {
        id: "publicChat",
        label: "Public chat",
        icon: ShareOutlinedIcon,
        sections: [
          { id: "accessLimits", label: "Access & limits" },
          { id: "shareLink", label: "Share link", requiresAgentId: true },
        ],
      },
      {
        id: "email",
        label: "Email",
        icon: EmailOutlinedIcon,
        sections: [
          { id: "inbox", label: "Inbox" },
          { id: "senderWhitelist", label: "Sender whitelist" },
          { id: "responseRules", label: "Response rules" },
          { id: "attachments", label: "Attachments" },
        ],
      },
    ],
  },
  {
    label: "Advanced",
    tabs: [
      {
        id: "advanced",
        label: "Advanced",
        icon: SettingsOutlinedIcon,
        sectionNavOnly: true,
        sections: [
          {
            id: "selfConfiguration",
            label: "Self configuration",
            hideForSystemAgent: true,
          },
          {
            id: "completionNotification",
            label: "Completion notification",
            hideForSystemAgent: true,
          },
          { id: "examplePrompts", label: "Example prompts" },
          { id: "transcriptVisibility", label: "Transcript visibility" },
          {
            id: "deleteAgent",
            label: "Delete agent",
            hideInCreateMode: true,
            hideForSystemAgent: true,
            hideForMasterAgent: true,
            requiresAgentId: true,
            danger: true,
          },
        ],
      },
    ],
  },
];

export const NAV_TABS = NAV_GROUPS.flatMap((group) => group.tabs);
